import request from '@/services/interceptor.js'

export const get_tipologie = () => {
    return request({ url: '/tipologie', method: 'get', loadingBar: true })
}

export const create_tipologia = (par) => {
    return request({ url: '/tipologie', method: 'post', data: par, loadingBar: true })
}

export const update_tipologia = (id, par) => {
    return request({ url: `/tipologie/${id}`, method: 'put', data: par, loadingBar: true })
}

export const delete_tipologia = (id) => {
    return request({ url: `/tipologie/${id}`, method: 'delete', loadingBar: true })
}
